import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.css";
import "./assets/styles/Global.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
ReactDOM.render(
  <React.StrictMode>
    <img
      id="main-logo"
      className="logo"
      src="https://impactrepublic.github.io/heliox/images/black_heliox.png"
      with={200}
      height={200}
      style={{ margin: "100px auto -100px", display: "block" }}
      alt="Helium-logo"
    />
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
